<div class="opportunity pt-0">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="heading mb-0 mt-2">{{inspection ? 'Inspection' : 'Estimate'}}</h3>
    <div *ngIf="preview" class="d-flex align-items-center">
      <button *ngIf="!review" class="btn base-btn estimate-btn"
        [disabled]="!((estimates || optionalEstimates) &&( estimates.length || optionalEstimates.length))"
        (click)="reviewEstimate()">Review Estimate</button>
    </div>

    <div *ngIf="viewerFlag">
      <button class="btn base-btn estimate-btn" (click)="callApi()">Download</button>
    </div>
  </div>
  <div class="opportunity-list">
    <div *ngIf="(estimates || optionalEstimates) &&( estimates.length || optionalEstimates.length); else noDataFound"
      class="table-responsive scroll-hide">
      <table class="table ">
        <thead class="p-2">
          <tr>
            <th scope="col" style="width: 48px;">Item</th>
            <!-- <th scope="col" style="width: 44px;">SKU</th> -->
            <th scope="col" style="width: 58px;">Image</th>
            <th scope="col">Item Name</th>
            <th scope="col">Description</th>
            <th scope="col">Video</th>
            <th scope="col" *ngIf="!inspection">Charge Type</th>
            <th scope="col" *ngIf="!inspection && hidePrice && !lumpSum ">Price</th>
            <th scope="col" *ngIf="!inspection && hidePrice && !lumpSum">Tax</th>
            <th scope="col" *ngIf="!inspection && hidePrice && !lumpSum">Qty</th>
            <th scope="col" *ngIf="!inspection && hidePrice && !lumpSum">Total</th>
            <th scope="col" *ngIf="inspection">Script</th>
            <th scope="col">Inspection</th>
            <th scope="col" *ngIf="!inspection && !work_order">Include</th>
            <th scope="col">Date</th>
            <th scope="col" *ngIf="!inspection">Status</th>
          </tr>
        </thead>
        <tbody class="">
          <ng-container *ngFor="let estimate of estimates;let i=index">
            <ng-container *ngIf="estimate?.isBundle else regularItems">
              <!-- Bundle header row -->
              <tr class="bundle-header-row handIcon" (click)="toggleBundle(estimate.bundleInstanceId)" (click)="review && viewEstimate(estimate)">
                <!-- Item index -->
                <td class="index-column">{{i + 1}}</td>
                <!-- SKU — bundles have no SKU -->
                <!-- <td>{{'---'}}</td> -->
                <td (click)="showImages(estimate.itemImage)">
                  <div *ngIf="estimate.images.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (estimate.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="estimate.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="estimate.images.length else noMedia" [src]="estimate.images[0].link" width="28px"
                      height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td [ngClass]="{'greyed-out-text': estimate?.quantity === 0}"><span [matTooltip]="estimate['itemName']">
                    {{ estimate['itemName'].length >
                    25 ? estimate['itemName'].slice(0, 25) + '...' :
                    estimate['itemName'] }}
                  </span></td>
                <td class="description">
                  <div>{{estimate['description']||'---'}}</div>
                </td>
                <td (click)="showImages(estimate.itemImage)">
                  <div *ngIf="estimate.videos.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (estimate.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="estimate.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="estimate.videos.length else noMedia" [src]="estimate.videos[0].link" width="28px"
                      height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>

                <td *ngIf="!inspection">{{estimate['chargeType'] || '---'}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' + (+estimate?.price || 0).toFixed(2)}}
                </td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' + (+estimate?.tax || 0).toFixed(2)}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{estimate['quantity']}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$'+(+estimate?.total || 0).toFixed(2)}}
                </td>
                <td *ngIf="inspection"
                  [ngClass]="{'description': !work_order, 'workDesc': work_order, 'greyed-out-text': estimate?.quantity === 0}">
                  <div>{{estimate['script']||'---'}}</div>
                </td>
                <td><span class="btn">{{'---'}}</span></td>
                <td *ngIf="!inspection && !work_order"><input class="form-check-input" type="checkbox"
                    [disabled]="estimate?.isEssential==true" (change)="selectEstimate($event,estimate._id,estimate)"
                    [checked]="estimate?.isInclude==true" /></td>
                <td>{{
                  (inspection
                  ? estimate['inspectionDate']
                  : estimate['createdAt']
                  )
                  ? ((inspection ? estimate['inspectionDate'] : estimate['createdAt']).replace(' ', 'T') |
                  date: dateFormat)
                  : '---'
                  }}</td>
                <td *ngIf="!inspection">
                  <span class="btn w-100"
                    [ngClass]="estimate['status'] == 0 ? 'orange-btn': estimate['status'] ==1 ? 'blue-btn' : estimate['status'] == 2 ? 'red-btn' : '---'">
                    {{estimate['status'] == 0 ? 'Pending Approval': estimate['status'] ==1 ? 'Approved' :
                    estimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
                  <!-- <span class="btn" [ngClass]="estimate.status === '0'? 'yellow-btn':'blue-btn'"> {{estimate['status'] === '0' ? 'Pending Approval': '---'}}</span> -->
                </td>
              </tr>

              <!-- Bundle child item rows (accordion) -->
              <ng-container *ngIf="isBundleExpanded(estimate.bundleInstanceId)">
                <tr *ngFor="let childItem of estimate.childItems; let ci = index"
                  (click)="review && viewEstimate(childItem)" class="bundle-child-row handIcon example-box">
                  <!-- Item index (indented sub-index) -->
                  <td [ngClass]="{'greyed-out-text': childItem?.quantity === 0}"
                    class="index-column bundle-child-index">
                    <span class="child-index-label"></span>
                  </td>
                  <!-- <td>{{childItem.sku}}</td> -->
                  <td (click)="showImages(childItem.itemImage)">
                    <div *ngIf="childItem.images.length >1 ; else showSingleImage" class="more-images ">
                      <span class="rounded-circle">{{'+'+ (childItem.images.length-1)}}</span>
                      <div class="image">
                        <img [src]="childItem.images[0].link" width="28px" height="28px" class="rounded-circle">
                      </div>
                    </div>
                    <ng-template #showSingleImage>
                      <img *ngIf="childItem.images.length else noMedia" [src]="childItem.images[0].link" width="28px"
                        height="28px" class="rounded-circle">
                      <ng-template #noMedia>
                        <div>---</div>
                      </ng-template>
                    </ng-template>
                  </td>
                  <td [ngClass]="{'greyed-out-text': childItem?.quantity === 0}"><span
                      [matTooltip]="childItem['itemName']">
                      {{ childItem['itemName'].length >
                      25 ? childItem['itemName'].slice(0, 25) + '...' :
                      childItem['itemName'] }}
                    </span></td>
                  <td class="description">
                    <div>{{childItem['description']||'---'}}</div>
                  </td>
                  <td (click)="showImages(childItem.itemImage)">
                    <div *ngIf="childItem.videos.length >1 ; else showSingleVideo" class="more-images ">
                      <span class="rounded-circle">{{'+'+ (childItem.videos.length-1)}}</span>
                      <div class="image">
                        <video [src]="childItem.videos[0].link" width="28px" height="28px"
                          class="rounded-circle"></video>
                      </div>
                    </div>
                    <ng-template #showSingleVideo>
                      <video *ngIf="childItem.videos.length else noMedia" [src]="childItem.videos[0].link" width="28px"
                        height="28px" class="rounded-circle"></video>
                      <ng-template #noMedia>
                        <div>---</div>
                      </ng-template>
                    </ng-template>
                  </td>

                  <td *ngIf="!inspection">{{childItem['chargeType']}}</td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' + (+childItem?.price || 0).toFixed(2)}}
                  </td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' + (+childItem?.tax || 0).toFixed(2)}}</td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{childItem['quantity']}}</td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$'+(+childItem?.total || 0).toFixed(2)}}
                  </td>
                  <td *ngIf="inspection"
                    [ngClass]="{'description': !work_order, 'workDesc': work_order, 'greyed-out-text': childItem?.quantity === 0}">
                    <div>{{childItem['script']||'---'}}</div>
                  </td>
                  <td><span class="btn"
                      [ngClass]="setInspectionStatus(childItem.inspectionId)">{{childItem?.inspection_data?.length
                      ? childItem?.inspection_data[0]?.fieldName : '---'}}</span></td>
                  <td *ngIf="!inspection && !work_order">
                  </td>
                  <td>{{
                    (inspection
                    ? childItem['inspectionDate']
                    : childItem['createdAt']
                    )
                    ? ((inspection ? childItem['inspectionDate'] : childItem['createdAt']).replace(' ', 'T') |
                    date: dateFormat)
                    : '---'
                    }}</td>
                  <td *ngIf="!inspection">
                    <span class="btn w-100"
                      [ngClass]="childItem['status'] == 0 ? 'orange-btn': childItem['status'] ==1 ? 'blue-btn' : childItem['status'] == 2 ? 'red-btn' : '---'">
                      {{childItem['status'] == 0 ? 'Pending Approval': childItem['status'] ==1 ? 'Approved' :
                      childItem['status'] == 2 ? 'Unapproved' : '---'}}</span>
                    <!-- <span class="btn" [ngClass]="childItem.status === '0'? 'yellow-btn':'blue-btn'"> {{childItem['status'] === '0' ? 'Pending Approval': '---'}}</span> -->
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #regularItems>
              <tr (click)="review && viewEstimate(estimate)">
                <td>{{i+1}}</td>
                <!-- <td>{{estimate.sku}}</td> -->
                <td (click)="showImages(estimate.itemImage)">
                  <div *ngIf="estimate.images.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (estimate.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="estimate.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="estimate.images.length else noMedia" [src]="estimate.images[0].link" width="28px"
                      height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td [ngClass]="{'greyed-out-text': estimate?.quantity === 0}"><span [matTooltip]="estimate['itemName']">
                    {{ estimate['itemName'].length >
                    25 ? estimate['itemName'].slice(0, 25) + '...' :
                    estimate['itemName'] }}
                  </span></td>
                <td class="description">
                  <div>{{estimate['description']||'---'}}</div>
                </td>
                <td (click)="showImages(estimate.itemImage)">
                  <div *ngIf="estimate.videos.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (estimate.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="estimate.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="estimate.videos.length else noMedia" [src]="estimate.videos[0].link" width="28px"
                      height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>

                <td *ngIf="!inspection">{{estimate['chargeType'] || '---'}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' + (+estimate?.price || 0).toFixed(2)}}
                </td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' + (+estimate?.tax || 0).toFixed(2)}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{estimate['quantity']}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$'+(+estimate?.total || 0).toFixed(2)}}
                </td>
                <td *ngIf="inspection"
                  [ngClass]="{'description': !work_order, 'workDesc': work_order, 'greyed-out-text': estimate?.quantity === 0}">
                  <div>{{estimate['script']||'---'}}</div>
                </td>
                <td><span class="btn"
                    [ngClass]="setInspectionStatus(estimate.inspectionId)">{{estimate?.inspection_data?.length
                    ? estimate?.inspection_data[0]?.fieldName : '---'}}</span></td>
                <td *ngIf="!inspection && !work_order"><input class="form-check-input" type="checkbox"
                    [disabled]="estimate?.isEssential==true" (change)="selectEstimate($event,estimate._id,estimate)"
                    [checked]="estimate?.isInclude==true" /></td>
                <td>{{
                  (inspection
                  ? estimate['inspectionDate']
                  : estimate['createdAt']
                  )
                  ? ((inspection ? estimate['inspectionDate'] : estimate['createdAt']).replace(' ', 'T') |
                  date: dateFormat)
                  : '---'
                  }}</td>
                <td *ngIf="!inspection">
                  <span class="btn w-100"
                    [ngClass]="estimate['status'] == 0 ? 'orange-btn': estimate['status'] ==1 ? 'blue-btn' : estimate['status'] == 2 ? 'red-btn' : '---'">
                    {{estimate['status'] == 0 ? 'Pending Approval': estimate['status'] ==1 ? 'Approved' :
                    estimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
                  <!-- <span class="btn" [ngClass]="estimate.status === '0'? 'yellow-btn':'blue-btn'"> {{estimate['status'] === '0' ? 'Pending Approval': '---'}}</span> -->
                </td>
              </tr>
            </ng-template>
          </ng-container>
        </tbody>
        <thead *ngIf="optionalEstimates && optionalEstimates.length" class="optional">
          <tr class="">
            <th colspan="15" class="">Optional Items</th>
          </tr>
        </thead>
        <tbody *ngIf="optionalEstimates && optionalEstimates.length">
          <ng-container *ngFor="let optionalEstimate of includedEstimates;let i=index">
            <ng-container *ngIf="optionalEstimate?.isBundle else regularOPI">
              <!-- Bundle header row -->
              <tr class="bundle-header-row handIcon" (click)="toggleBundle(optionalEstimate.bundleInstanceId)" (click)="review && viewEstimate(optionalEstimate)">
                <!-- Item index -->
                <td [ngClass]="{'greyed-out-text': optionalEstimate?.quantity === 0}" class="index-column">
                  {{i+(estimates.length+1)}}</td>
                <!-- SKU — bundles have no SKU -->
                <!-- <td>{{'---'}}</td> -->
                <td (click)="showImages(optionalEstimate.itemImage)">
                  <div *ngIf="optionalEstimate.images.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (optionalEstimate.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="optionalEstimate.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="optionalEstimate.images.length else noMedia" [src]="optionalEstimate.images[0].link"
                      width="28px" height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td [ngClass]="{'greyed-out-text': optionalEstimate?.quantity === 0}">
                  <span [matTooltip]="optionalEstimate['itemName']">
                    {{ optionalEstimate['itemName'].length >
                    25 ? optionalEstimate['itemName'].slice(0, 25) + '...' :
                    optionalEstimate['itemName'] }}
                  </span>
                </td>
                <td class="description">
                  <div>{{optionalEstimate['description']}}</div>
                </td>
                <td (click)="showImages(optionalEstimate.itemImage)">
                  <div *ngIf="optionalEstimate.videos.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (optionalEstimate.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="optionalEstimate.videos[0].link" width="28px" height="28px"
                        class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="optionalEstimate.videos.length else noMedia" [src]="optionalEstimate.videos[0].link"
                      width="28px" height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <!-- <td class="description">
                                <div>{{optionalEstimate['script']}}</div></td> -->
                <td>{{optionalEstimate['chargeType'] || '---'}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$'+ (+optionalEstimate?.price ||
                  0).toFixed(2)}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' +(+optionalEstimate?.tax || 0).toFixed(2)}}
                </td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{optionalEstimate['quantity']}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$ '+(+optionalEstimate?.total || 0).toFixed(2)}}
                </td>
                <td><span class="btn">{{'---'}}</span></td>
                <td *ngIf="!inspection && !work_order"><input class="form-check-input" type="checkbox"
                    [checked]='optionalEstimate.isInclude' [disabled]="!review"
                    (change)="selectEstimate($event,optionalEstimate._id,optionalEstimate)" /></td>
                <td>{{optionalEstimate['createdAt'].replace(' ','T')| date: dateFormat}}</td>
                <td>
                  <span class="btn w-100"
                    [ngClass]="optionalEstimate['status'] == 0 ? 'orange-btn': optionalEstimate['status'] == 1 ? 'blue-btn' : optionalEstimate['status'] == 2 ? 'red-btn' : '---'">{{optionalEstimate['status']
                    == 0 ? 'Pending Approval': optionalEstimate['status'] == 1 ? 'Approved' :
                    optionalEstimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
                </td>
              </tr>

              <!-- Bundle child item rows (accordion) -->
              <ng-container *ngIf="isBundleExpanded(optionalEstimate.bundleInstanceId)">
                <tr *ngFor="let childItem of optionalEstimate.childItems; let ci = index"
                  (click)="review && viewEstimate(childItem)" class="bundle-child-row handIcon example-box">
                  <!-- Item index (indented sub-index) -->
                  <td [ngClass]="{'greyed-out-text': childItem?.quantity === 0}"
                    class="index-column bundle-child-index">
                    <span class="child-index-label"></span>
                  </td>
                  <!-- <td>{{childItem.sku}}</td> -->
                  <td (click)="showImages(childItem.itemImage)">
                    <div *ngIf="childItem.images.length >1 ; else showSingleImage" class="more-images ">
                      <span class="rounded-circle">{{'+'+ (childItem.images.length-1)}}</span>
                      <div class="image">
                        <img [src]="childItem.images[0].link" width="28px" height="28px" class="rounded-circle">
                      </div>
                    </div>
                    <ng-template #showSingleImage>
                      <img *ngIf="childItem.images.length else noMedia" [src]="childItem.images[0].link" width="28px"
                        height="28px" class="rounded-circle">
                      <ng-template #noMedia>
                        <div>---</div>
                      </ng-template>
                    </ng-template>
                  </td>
                  <td [ngClass]="{'greyed-out-text': childItem?.quantity === 0}">
                    <span [matTooltip]="childItem['itemName']">
                      {{ childItem['itemName'].length >
                      25 ? childItem['itemName'].slice(0, 25) + '...' :
                      childItem['itemName'] }}
                    </span>
                  </td>
                  <td class="description">
                    <div>{{childItem['description']}}</div>
                  </td>
                  <td (click)="showImages(childItem.itemImage)">
                    <div *ngIf="childItem.videos.length >1 ; else showSingleVideo" class="more-images ">
                      <span class="rounded-circle">{{'+'+ (childItem.videos.length-1)}}</span>
                      <div class="image">
                        <video [src]="childItem.videos[0].link" width="28px" height="28px"
                          class="rounded-circle"></video>
                      </div>
                    </div>
                    <ng-template #showSingleVideo>
                      <video *ngIf="childItem.videos.length else noMedia" [src]="childItem.videos[0].link" width="28px"
                        height="28px" class="rounded-circle"></video>
                      <ng-template #noMedia>
                        <div>---</div>
                      </ng-template>
                    </ng-template>
                  </td>
                  <!-- <td class="description">
                                <div>{{optionalEstimate['script']}}</div></td> -->
                  <td>{{childItem['chargeType']}}</td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$'+ (+childItem?.price ||
                    0).toFixed(2)}}</td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' +(+childItem?.tax || 0).toFixed(2)}}
                  </td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{childItem['quantity']}}</td>
                  <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$ '+(+childItem?.total || 0).toFixed(2)}}
                  </td>
                  <td><span class="btn"
                      [ngClass]="setInspectionStatus(childItem.inspectionId)">{{childItem.inspectionStatus
                      || '---'}}</span></td>
                  <td *ngIf="!inspection && !work_order">
                  </td>
                  <td>{{childItem['createdAt'].replace(' ','T')| date: dateFormat}}</td>
                  <td>
                    <span class="btn w-100"
                      [ngClass]="childItem['status'] == 0 ? 'orange-btn': childItem['status'] == 1 ? 'blue-btn' : childItem['status'] == 2 ? 'red-btn' : '---'">{{childItem['status']
                      == 0 ? 'Pending Approval': childItem['status'] == 1 ? 'Approved' :
                      childItem['status'] == 2 ? 'Unapproved' : '---'}}</span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #regularOPI>
              <tr (click)="review && viewEstimate(optionalEstimate)">
                <td>{{i+(estimates.length+1)}}</td>
                <!-- <td>{{optionalEstimate.sku}}</td> -->
                <td (click)="showImages(optionalEstimate.itemImage)">
                  <div *ngIf="optionalEstimate.images.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (optionalEstimate.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="optionalEstimate.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="optionalEstimate.images.length else noMedia" [src]="optionalEstimate.images[0].link"
                      width="28px" height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td [ngClass]="{'greyed-out-text': optionalEstimate?.quantity === 0}">
                  <span [matTooltip]="optionalEstimate['itemName']">
                    {{ optionalEstimate['itemName'].length >
                    25 ? optionalEstimate['itemName'].slice(0, 25) + '...' :
                    optionalEstimate['itemName'] }}
                  </span>
                </td>
                <td class="description">
                  <div>{{optionalEstimate['description']}}</div>
                </td>
                <td (click)="showImages(optionalEstimate.itemImage)">
                  <div *ngIf="optionalEstimate.videos.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (optionalEstimate.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="optionalEstimate.videos[0].link" width="28px" height="28px"
                        class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="optionalEstimate.videos.length else noMedia" [src]="optionalEstimate.videos[0].link"
                      width="28px" height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <!-- <td class="description">
                                <div>{{optionalEstimate['script']}}</div></td> -->
                <td>{{optionalEstimate['chargeType'] || '---'}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$'+ (+optionalEstimate?.price ||
                  0).toFixed(2)}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$' +(+optionalEstimate?.tax || 0).toFixed(2)}}
                </td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{optionalEstimate['quantity']}}</td>
                <td *ngIf="!inspection && hidePrice && !lumpSum">{{'$ '+(+optionalEstimate?.total || 0).toFixed(2)}}
                </td>
                <td><span class="btn"
                    [ngClass]="setInspectionStatus(optionalEstimate.inspectionId)">{{optionalEstimate.inspectionStatus
                    || '---'}}</span></td>
                <td *ngIf="!inspection && !work_order"><input class="form-check-input" type="checkbox"
                    [checked]='optionalEstimate.isInclude' [disabled]="!review"
                    (change)="selectEstimate($event,optionalEstimate._id,optionalEstimate)" /></td>
                <td>{{optionalEstimate['createdAt'].replace(' ','T')| date: dateFormat}}</td>
                <td>
                  <span class="btn w-100"
                    [ngClass]="optionalEstimate['status'] == 0 ? 'orange-btn': optionalEstimate['status'] == 1 ? 'blue-btn' : optionalEstimate['status'] == 2 ? 'red-btn' : '---'">{{optionalEstimate['status']
                    == 0 ? 'Pending Approval': optionalEstimate['status'] == 1 ? 'Approved' :
                    optionalEstimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
                </td>
              </tr>
            </ng-template>
          </ng-container>
        </tbody>
      </table>
    </div>
    <ng-container *ngIf="!inspection">
      <div
        *ngIf="(hidePrice || lumpSum) && (review && (estimates || optionalEstimates) &&( estimates.length || optionalEstimates.length))"
        class="w-100">
        <hr class="dashed-line" />
        <div class="py-3 d-flex flex-column align-items-end">
          <div class="d-flex justify-content-between align-items-center amount">
            <h3 class="amount-heading pb-0 mb-0 mx-1">SubTotal:</h3>
            <!-- <div class="d-flex align-items-center">
                        <label class="label px-2">Amount</label>
                        <span class="totalAmount" *ngIf="!review">{{'$'+ calculateAmount()}}</span>
                        <span class="totalAmount" *ngIf="review">{{'$'+ totalAmount}}</span>
                    </div> -->

            <span class="amount-heading" *ngIf="!review">{{'$'+ calculateAmount('total')}}</span>
            <span class="amount-heading" *ngIf="review">{{'$'+ (totalAmount - taxAmount).toFixed(2)}}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center amount">
            <h3 class="amount-breakup pb-0 mb-0 mx-1">Tax:</h3>
            <!-- <span class="amount-breakup"*ngIf="!review">{{'$'+ calculateAmount()}}</span> -->
            <span class="amount-breakup" *ngIf="review">{{'$'+ taxAmount}}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center amount">
            <h3 class="amount-breakup pb-0 mb-0 mx-1">Total:</h3>
            <!-- <span class="amount-breakup"*ngIf="!review">{{'$'+ calculateAmount()}}</span> -->
            <span class="amount-breakup" *ngIf="review">{{'$'+ totalAmount}}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noDataFound>
      <div class="no-data">No Estimate Found.</div>
    </ng-template>
  </div>
  <ng-container *ngIf="isPreferredUser && !inspection">
    <div class="d-flex align-items-center justify-content-center mt-2" *ngIf="location">
      <button [disabled]="!approveEstimateIds.length || (!hidePrice && !lumpSum)"
        class="btn d-flex base-btn estimate-btn approve-btn" (click)="approveEstimate()">Approve All Selected
        Items</button>
    </div>
  </ng-container>

</div>
